<template>
  <div>
    <b-input
      :label="linkTitle"
      :value="input.account"
      :autocomplete="'new-channel'"
      @input="onInput"
      :error="this.$v.input.account.$error || !!error"
      :custom-error="customError ? customError : error"
      :show-validate-icons="true"
      :v="this.$v.input.account">
    </b-input>
  </div>
</template>
<script>
import Vue from 'vue'
import BInput from "@/components/__new_ui_kit/Input/BInput";
import required from "vuelidate/lib/validators/required";
import {checkSocialLink} from "@/utils/validations/checkSocialLink";
import helper from "@/store/helpers/helper";
export default Vue.extend({
  props: {
    item: {
      type: Object
    },
    input: {
      type: Object
    },
    error: {
      type: String
    }
  },
  components: {
    BInput
  },
  validations: {
    input : {
      account: {
        required,
        checkSocialLink: checkSocialLink
      }
    }
  },
  computed: {
    linkTitle() {
      switch (this.item.name) {
        case 'Instagram':
        case 'Facebook':
          return `${this.item.name} destination`
        case 'Twitter':
          return `X (Twitter) destination`
        case 'Telegram_channel':
          return 'Telegram channel'
        default:
          return `${this.item.name} account`
      }
    },
    linkTooltip() {
      switch (this.item.name) {
        case 'Facebook':
          return 'Insert the URL link of your account, group or page'
        case 'Instagram':
          return 'Insert the URL link of your account or post'
        case 'YouTube':
          return 'Insert the URL link of your account'
        case 'Twitter':
          return 'Insert the URL link of your account or twit'
        case 'TikTok':
          return 'Insert the URL link of your account or video'
        case 'LinkedIn':
          return  'Insert the URL link of your account or page'
        default:
          return ''
      }
    },
    customError() {
      return helper.checkLink(this.input.account, this.item.icon).message
    }
  },
  methods: {
    onInput(data) {
      this.$emit('change-link', {
        id: parseInt(this.input.id),
        data
      })
    }
  },
  created() {
    // если создается новый, то сразу не красится в ошибку, может надо наооборот...
    if (this.input.account) {
      this.$v.$touch()
    }
  }
})
</script>
<style scoped lang="scss"></style>